export const API_PARTNERS_FIELDS = [
    'partners.id',
    'partners.status',
    'partners.sort',
    'partners.image.id',
    'partners.translations'
];
export const API_PROJECT_PARTNERS_ID_FIELDS = [
    'partners.partner_id.id',
    'partners.partner_id.status',
    'partners.partner_id.sort',
    'partners.partner_id.image.id',
    'partners.partner_id.translations'
];
